<template>
  <v-dialog v-model="createShapeModal" max-width="800px" persistent>
    <v-card>
      <v-toolbar color="#425058" dark dense>
        <div class="titleBar-content">
          <v-toolbar-title class="raceResults-title"> Create Shape </v-toolbar-title>
          <v-btn class="cancelButton" icon small @click="closeModal" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
        </div>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-row no-gutters justify="space-between">
          <v-col cols="7">
            <v-text-field
              v-if="fragment !== null"
              :disabled="true"
              outlined
              class="mt-1"
              label="Fragment"
              dense
              :value="fragment.toLowerCase()"
              :rules="[rules.required]">
            </v-text-field>
            <v-text-field
              outlined
              v-model="name"
              class="mt-1"
              label="Shape Description"
              dense
              @blur="checkIfNameExist"
              :rules="[rules.required]"
              :error-messages="errorMessages"
              :hide-details="errorMessages === null"
            >
            </v-text-field>
            <v-checkbox v-model="twoColors" label="Does shape include 2 colors? (Excluding main color)"></v-checkbox>
            <v-select v-model="section" outlined label="Section" dense :items="items" @blur="checkIfNameExist"></v-select>
            <Svgupload :addDefs="addDefs" :clearInput="clearUploadInput"/>
            <v-textarea outlined label="Defs" v-model="defs" hide-details dense></v-textarea>
            <v-btn v-if="defs !== ''" small class="white--text" color="blue" style="margin-top: 12px; margin-bottom: 12px;" @click="modifyDefs">Update SVG preview</v-btn>
          </v-col>
          <v-col cols="4" class="mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 50">
              <defs v-html="defs"></defs>
              <g>
                <polygon fill="#010202" points="8.562 50 24.678 50 24.678 46.588 8.562 46.588"></polygon>
                <path class="default sleeves" :style="section === 'all' ? colorForPreview : section === 'sleeves' ? 'fill:url(#shape-preview)' : 'fill:#fff'" d="M27.8087,50 L24.2977,50 C24.2977,50 23.8087,42.914 24.2977,41.564 C24.7867,40.216 24.9027,25.472 24.7157,25.216 C24.5307,24.96 25.5687,25.239 25.9447,28.426 C26.3207,31.611 26.8317,33.82 27.1347,34.564 C27.4367,35.309 28.0877,42.877 27.8087,50"></path>
                <path class="default torso" :style="section === 'all' ? colorForPreview : section === 'torso' ? 'fill:url(#shape-preview)' : 'fill:#fff'" d="M24.7979,24.751 C23.5069,22.169 19.2689,20.705 19.2689,20.705 L18.0299,21.123 L17.5069,21.123 C13.9289,19.263 9.0889,18.169 9.0889,18.169 C8.4839,18.169 0.4839,19.239 0.4839,27.519 C0.4839,35.798 3.0419,47.564 3.5999,47.844 C4.1579,48.123 14.0189,48.03 17.6929,48.03 C17.6929,48.03 25.4949,48.437 25.7039,46.658 C25.7039,44.32 26.0879,27.332 24.7979,24.751"></path>
                <g transform="translate(0, 22)">
                  <path class="default sleeves" :style="section === 'all' ? colorForPreview : section === 'sleeves' ? 'fill:url(#shape-preview)' : 'fill:#fff'" d="M3.5303,28 C3.5303,28 2.9023,27.007 2.5763,26.704 C2.2513,26.402 1.7393,24.658 1.7623,24.123 C1.7853,23.588 1.2973,21.309 0.9023,20.658 C0.5073,20.007 -0.3537,16.076 0.1573,11.635 C-0.2377,7.867 -0.2377,1.077 5.5763,0.681 C11.3903,0.286 11.4133,7.239 10.7853,10.426 C10.1573,13.611 9.9713,14.681 9.2973,14.867 C8.6233,15.054 8.9023,16.402 9.0883,16.588 C9.2743,16.774 9.6463,17.774 9.1813,18.332 C8.7163,18.891 8.0413,19.379 8.5303,20.007 C9.0183,20.635 10.2743,25.053 9.9253,25.867 C9.5763,26.681 10.2273,28 10.2273,28 L3.5303,28 Z"></path>
                </g>
                <g transform="translate(9, 0)">
                  <path class="default cap" :style="section === 'all' ? colorForPreview : section === 'cap' ? 'fill:url(#shape-preview)' : 'fill:#fff'" d="M8.0626,4.7856 C10.9276,4.7856 13.4606,5.7056 15.0446,7.1196 C14.6946,3.1266 11.5136,-0.0004 7.6376,-0.0004 C3.5266,-0.0004 0.1936,3.5156 0.1936,7.8516 C0.1936,7.9306 0.2036,8.0076 0.2056,8.0856 C1.5976,6.1376 4.5876,4.7856 8.0626,4.7856"></path>
                </g>
                <path d="M24.0801,7.8521 C24.0801,7.6051 24.0661,7.3611 24.0451,7.1201 C22.4611,5.7061 19.9281,4.7861 17.0621,4.7861 C13.5871,4.7861 10.5981,6.1371 9.2051,8.0851 C9.2181,8.5591 9.2651,9.0241 9.3541,9.4731 C9.6821,9.0591 10.0921,8.6801 10.5561,8.3321 C10.6871,8.2941 11.6951,8.0241 11.7271,8.6111 C11.7631,9.2391 11.2971,10.3551 11.1281,10.6231 C10.9601,10.8911 10.5401,11.9601 10.5291,12.2271 C10.5181,12.4951 9.9371,13.2741 9.8321,13.4141 C9.7271,13.5531 10.9251,14.9141 11.2391,14.8551 C11.5531,14.7971 11.3911,14.5301 11.4491,13.7741 C11.5071,13.0191 11.9601,10.7051 12.4721,10.1931 C12.9791,9.6851 12.8811,7.3551 12.7711,7.1401 C14.0381,6.6611 15.4981,6.3791 17.0621,6.3791 C17.9761,6.3791 18.8511,6.4811 19.6781,6.6551 C19.9151,6.7531 21.0861,7.2601 21.2741,7.7511 C21.4831,8.2971 21.5181,8.9021 21.5071,9.0301 C21.4951,9.1581 21.3791,14.4831 21.2861,14.5651 C21.1921,14.6461 19.8671,15.7511 19.9721,16.1231 C20.0761,16.4951 20.5641,17.0411 20.8551,16.7971 C21.1461,16.5531 22.1921,15.8321 21.9721,15.1691 C21.7511,14.5071 21.7161,10.6231 22.1351,10.1931 C22.5481,9.7681 23.7101,8.6571 23.7421,8.4721 C23.8391,8.5501 23.9441,8.6231 24.0351,8.7041 C24.0631,8.4241 24.0801,8.1401 24.0801,7.8521" fill="#010202"></path>
                <polygon class="default collar" :style="section === 'all' ? colorForPreview : section === 'collar' ? 'fill:url(#shape-preview)' : 'fill:#fff'" points="18.0303 18.9253 18.0303 21.1233 19.2683 20.7043 19.2683 17.6873"></polygon>
                <path class="default collar" :style="section === 'all' ? colorForPreview : section === 'collar' ? 'fill:url(#shape-preview)' : 'fill:#fff'" d="M17.5069,18.5879 C17.5069,18.5879 12.9029,15.7049 12.4369,15.7049 C11.9719,15.7049 10.9489,16.0299 10.9489,17.1929 C10.9489,18.3559 9.6929,18.1699 9.0889,18.1699 C9.0889,18.1699 13.9289,19.2629 17.5069,21.1229 L17.5069,18.5879 Z"></path>
              </g>
            </svg>
          </v-col>
        </v-row>
        <v-row no-gutters justify="space-between">
          <v-col cols="12">
            <v-btn small class="white--text mt" color="success" @click="saveShape" :disabled="name === '' || saveDisable">Save</v-btn>
            <v-btn small class="white--text ml-2 mt" color="error" @click="closeModal">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Svgupload from "../components/Svgupload"

  export default {
    data: () => ({
      items: ['sleeves', 'cap', 'collar', 'torso'],
      name: '',
      section: null,
      defs: '',
      colorForPreview: '#FFF',
      twoColors: false,
      errorMessages: null,
      saveDisable: false,
      clearUploadInput: false,
      rules: {
        required: value => !!value || 'Shape name is required',
      }
    }),
    props: {
      createShapeModal: Boolean,
      newSection: String,
      fragment: String,
      closeCreateShapeModal: Function,
      shapeToEdit: Object
    },
    components: {
      Svgupload
    },
    computed: {
      ...mapGetters(['getShapes']),
      sectionSelected () {
        return this.newSection
      }
    },
    watch: {
      sectionSelected() {
        this.section = this.newSection
      },
      shapeToEdit () {
        if (this.shapeToEdit !== null) {
          this.name = this.shapeToEdit.name
          this.section = this.shapeToEdit.section
          this.defs = this.shapeToEdit.defs
          this.twoColors = this.shapeToEdit.twoColors
        }
      }
    },
    methods: {
      ...mapActions(['createShape', 'fetchShapes', 'updateShape']),
      checkIfNameExist () {
        if (this.name != '' && this.section !== null) {
          const shapes = this.getShapes
          const exist = shapes.filter(shape => shape.section === this.section && shape.name === this.name)
          if (exist.length > 0) {
            this.errorMessages = `Shape ${this.name} with ${this.section} section is already taken`
            this.saveDisable = true
          } else {
            this.errorMessages = null
            this.saveDisable = false
          }
        }
      },
      selectedSection () {
        this.section = this.newSection
      },
      addDefs (d) {
        if (d === "") {
          this.defs = ""
        } else {
          if (this.twoColors) {
            const defsExtracted = d.substring(
              d.lastIndexOf('<g'),
              d.lastIndexOf('</g>') + 4
            ).split('\n')

            let newDefs = ''
            for (let index = 2; index < defsExtracted.length - 1; index++) {
              newDefs += defsExtracted[index] + '\n'
            }

            this.defs = `<pattern id="{{.ID}}" x="0" y="0" width="10" height="10">
            <rect width="100%" height="100%" fill="{{.BaseColor}}" />${newDefs}</pattern>`
          } else {
            // const newDefs = d.substring(
            //   d.lastIndexOf('<p'),
            //   d.lastIndexOf('/>') + 2
            // )
            const defsExtracted = d.substring(
              d.lastIndexOf('<g'),
              d.lastIndexOf('</g>') + 4
            ).split('\n')

            let newDefs = ''
            for (let index = 2; index < defsExtracted.length - 1; index++) {
              newDefs += defsExtracted[index] + '\n'
            }

            this.defs = `<pattern id="{{.ID}}" x="0" y="0" width="10" height="10">
            <rect width="100%" height="100%" fill="{{.BaseColor}}" />${newDefs}</pattern>`
          }
        }
      },
      closeModal () {
        this.name = ''
        this.section = null
        this.defs = ''
        this.clearUploadInput = true
        this.closeCreateShapeModal()
      },
      modifyDefs () {
        const IDExists = this.defs.search('<pattern id="')
        if (IDExists === -1) {
          this.defs = this.defs.replace(/<pattern/g, '<pattern id="shape-preview"')
        } else {
          this.defs = this.defs.replace(/id=".*?"/, 'id="shape-preview"');
        }

        const fillExist = (this.defs.match(/fill="([^"]+)"/g) || []).length

        if (this.section === 'sleeves' && fillExist > 2) {
          let t = 0
          this.defs = this.defs.replace(/fill="([^"]+)"/g, function (match) {
            t++;
            if (t === 1 || t === 2 || t === 4){
              return 'fill="#FFF"'
            } else if (t === 3) {
              return 'fill="#000"'
            } else {
              return match
            }
          });
        } else if (this.section === 'torso' && fillExist > 2 && this.twoColors) {
          let t = 0
          this.defs = this.defs.replace(/fill="([^"]+)"/g, function (match) {
            t++;
            if (t === 1 ){
              return 'fill="#C4C4C4"'
            } else if (t === 2) {
              return 'fill="#FFF"'
            } else if (t === 3) {
              return 'fill="#000"'
            } else {
              return match
            }
          });
        } else {
          let t = 0
          this.defs = this.defs.replace(/fill="([^"]+)"/g, function () {
            t++;
            if (t === 1){
              return 'fill="#FFF"'
            } else if (t === 2) {
              return 'fill="#000"'
            }
          });
        }
      },
      async saveShape () {
        if (this.shapeToEdit !== null) {
          await this.updateShape({ id: this.shapeToEdit.id, name: this.name, section: this.section, defs: this.defs, twoColors: this.twoColors })
        } else {
          await this.createShape({ name: this.name, section: this.section, defs: this.defs, twoColors: this.twoColors })
        }
        this.closeModal()
        await this.fetchShapes()
      }
    }
  }
</script>